module.exports = __webpack_public_path__ + "static/media/bg_indicadores.b78fecab.jpg";